 <template>
  <div class="result-view">
    <b-container>
      <booking-engine @search="on_booking_engine_search"/>
      <section class="section filters">
        <b-row>
          <b-col cols="3" class="filters__sticky-wrapper" :class="{ visible: show_filters, clickable: !searching }">
            <div v-if="searching || hotels.length" class="filters__sticky-wrapper__inner">
              <div class="filters__head mb-4">

                <div class="filters__head-element toggle-map-button" @click="toggle_map_view()">
                  <div v-if="!map">
                    <div class="toggle-map-button__text">
                      Vedi su mappa
                    </div>
                    <div class="toggle-map-button__image">
                      <svg width="177" height="65" viewBox="0 0 177 65" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><rect width="177" height="65" rx="10" fill="#F1F1F1"></rect><rect width="177" height="65" rx="10" fill="url(#pattern0-image-svg-map-link-small)"></rect><rect x="72" y="12" width="33" height="41" fill="url(#pattern1-image-svg-map-link-small)"></rect><defs><pattern id="pattern0-image-svg-map-link-small" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#image-svg-map-link-small" transform="translate(-0.762712) scale(0.00564972 0.0153846)"></use></pattern><pattern id="pattern1-image-svg-map-link-small" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#image1-svg-map-link-small" transform="scale(0.030303 0.0243902)"></use></pattern><image id="image-svg-map-link-small" width="447" height="65" xlink:href="data:image/png;base64,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"></image><image id="image1-svg-map-link-small" width="33" height="41" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAApCAYAAAC7t0ACAAAABHNCSVQICAgIfAhkiAAAAstJREFUWEe9mM11GkEMx/8C34MrCKkguILAM+SauAKTCrJUYLuCXSowrsDkavDDqQCnAjsVJL4DypuZ3QWWHY/E4syFw2o0v9HHSIKgWYPJFzDaALUAboDMLwDmR4D+AngG8Rhx74dGLQWFo1kDWFwA1AehEZS3UDBAY6B+haTzHNrzOkR0fwFwJD68eJqFoQSoDZF0DFjpKodwt5/l5g5dJfTduuvozGeVXYjorgXUbkFohnSrvlurrDpIPj8W921DWAss5wcHyE61IPWTokUKEJP5wVzgM5NzTWczRtYQ0eQSRBcqE+8vPETcjbLtDsK54UmRBTdgm4IPTtGiBaI+gHMxF9c/ZG5xEINpAuB7WAG/gLldFlzuMncG5gGgd2FduEHcNeBILTH9I7ICr068ANmpFqQ2F0AAXD82sUGIpl9BuBVsysmDslLLMn1DcjoisSsYZ0i64yBA7haRNezFCIOJ8eGnoPLUdEG5TGAw5bAs/0TcaxMi4dvwJhAA4i4ZdwiIbbnuIOmlKRm4oyY4VRBYp1TQzJqHz0EIY8KcLE1R1GailAe/IO41lBD+Spg/VqBref1ZB6a+ZjBGwGqYP1y2/NO5qvtyPk1TVBNEwWBQCqRvT1Y7TB/4XqmioriLh3XtkD6zFY8tbC8WsFkTtHw67BkBbTul3JXzkaofqEa8VQw3OitjjYUZYiS9QDWEDSusYyLvBf5Li7fV2u1COLeYlvxjtat6d/8G11vFQah87pB2RlpSTxH0TGBv4pYdN2R38M+imsIWtsgvxF03wZcsP4QZA2hp4qPiS2o69KOmfiDOs0XVwpdfU9AMCf6fEHfjuxBpNx3yVhjCaIju+yC+Dinb+i4EKH8nfCfpQLyZoAvMMmkZiHxISs+QuWMT6HUQNYDOHSEQ5iskvUtV3OxtiTx9N4JVEYTVY6KowTa4piCdml5k7/UP6AojOUui3UAAAAAASUVORK5CYII="></image></defs></svg>
                    </div>
                  </div>
                  <div v-if="map">
                    <div class="toggle-map-button__text">
                      Vedi su lista
                    </div>
                    <div class="toggle-map-button__image icon">
                      <vb-icon :name="'list'" :color="'888888'" />
                    </div>
                  </div>
                </div>

                <vb-icon
                  class="filters__content-close"
                  :name="'cross_circle'"
                  :size=25
                  :color="sass('gray-600')"
                  @click="toggle_filters()"
                />
              </div>
              
              <div class="filters__content-wrapper" :key="ui_key_filter">

                <!-- filter availability -->
                <div class="mb-2">
                  <vb-checkbox
                    @change="value => {
                        filter_update_handler(
                          () => { $store.commit('livebkv3/filter_availability', value) }
                        )
                      }"
                    :vb_options="{
                      text: 'Mostra in base al credito',
                      switch: true,
                      value: filter_availability
                    }"
                  />
                </div>

                <!-- refundable -->
                <div class="mb-4" v-if="filters.cancellation_type">
                  <vb-checkbox
                    @change="value => {
                      filter_update_handler(
                        () => { $store.commit('livebkv3/filter_cancellation_type', value) }
                      )                      
                    }"
                    :vb_options="{
                      text: filters.cancellation_type.label,
                      switch: true,
                      value: filter_cancellation_type,
                    }"/>
                </div>

                <div v-if="active_filters().length" class="mb-3">
                  <hr />
                  <p class="d-flex align-items-center justify-content-between">
                    <span class="filters__section__title">Filtri attivi:</span>
                    <span
                      class="text--sm text-info underline cursor-pointer w-100 d-flex justify-content-end"
                      @click="() => {
                          trigger_new_search()
                        }">
                      cancella filtri
                    </span>
                  </p>

                  <b-badge pill variant="primary" class="d-inline-flex mr-1 cursor-pointer mb-1"
                    v-for="(filter, index) in active_filters()"
                    @click="() => {
                      filter.callback()
                    }"
                    v-bind:key="_uid+index+'-page-active'">
                    <div v-html="filter.text" />
                    <div class="ml-2">&#10005;</div>                  
                  </b-badge>

                </div>

                <!-- accommodation_types -->
                <div class="filters__panel mb-3" v-if="filters.accommodation_types && filters.accommodation_types.values">
                  <p class="filters__section__title">{{ filters.accommodation_types.label }}</p>
                  <div class="filters__hotel-categories__item"
                    v-for="(category,index) in Object.keys(filters.accommodation_types.values)"
                    v-bind:key="_uid+index+'_type'"
                    :class="{ active: filter_accommodation_types.includes(category) }"
                    @click.stop="() => {
                      filter_update_handler(
                        () => {
                          if(filter_accommodation_types.includes(category)) {
                            $store.commit('searching', true)
                            $store.commit('livebkv3/filter_accommodation_types', filter_accommodation_types.filter(c => { return c!==category }))
                          }
                          else {
                            $store.commit('searching', true)
                            $store.commit('livebkv3/filter_accommodation_types', [...filter_accommodation_types, category])
                          }
                        }
                      )                      
                    }">
                    <div class="filters__hotel-categories__name">{{ category }}</div>
                  </div>
                </div>

                <!-- price -->
                <div class="filters__panel mb-3" v-if="filters.price && filters.price.values">
                  <p class="filters__section__title">{{ filters.price.label }}</p>
                  <vb-checkbox
                    v-for="(price, index) in Object.keys(filters.price.values)"
                    v-bind:key="index"
                    @change="value => {
                      filter_update_handler(
                        () => {
                          if (value) {
                            $store.commit('searching', true)
                            $store.commit('livebkv3/filter_price', {
                              ...filters.price.values[price],
                              label: get_price_filter_label(price),
                            })
                          }
                          else {
                            $store.commit('searching', true)
                            $store.commit('livebkv3/filter_price', {})
                          }
                        }
                      )
                    }"
                    :vb_options="{
                      type: 'light',
                      text: get_price_filter_label(price),
                      value: (filter_price && filter_price.minimum == filters.price.values[price].minimum && filter_price.maximum == filters.price.values[price].maximum),
                    }"/>
                </div>
                
                <!-- meal_plan -->
                <div class="filters__panel mb-3" v-if="filters.meal_plan && filters.meal_plan.values">
                  <p class="filters__section__title">{{ filters.meal_plan.label }}</p>
                  <vb-checkbox
                    v-for="(meal_plan, index) in Object.keys(filters.meal_plan.values)"
                    v-bind:key="index"
                    @change="(value) => {
                      filter_update_handler(
                        () => {
                          if (value) {
                            $store.commit('searching', true)
                            $store.commit('livebkv3/filter_meal_plan', filters.meal_plan.values[meal_plan])
                          }
                          else {
                            $store.commit('searching', true)
                            $store.commit('livebkv3/filter_meal_plan', '')
                          }
                        }
                      )
                    }"
                    :vb_options="{
                      type: 'light',
                      text: `${meal_plan}`,
                      value: filter_meal_plan == filters.meal_plan.values[meal_plan],
                    }"/>
                </div>

                <!-- filter rating: minimum_review_score || stars -->
                <div v-if="filters.rating">

                  <!-- filter rating: minimum_review_score -->
                  <div class="filters__panel mb-3" v-if="filters.rating.minimum_review_score && filters.rating.minimum_review_score.values">
                    <p class="filters__section__title">{{ filters.rating.minimum_review_score.label }}</p>

                    <vb-checkbox
                      v-for="(review_score, index) in (Object.keys(filters.rating.minimum_review_score.values))"
                      v-bind:key="index"
                      @change="(value) => {
                        filter_update_handler(
                          () => {
                            if (value) {
                              $store.commit('searching', true)
                              $store.commit('livebkv3/filter_rating', {
                                ...filter_rating,
                                minimum_review_score: [
                                  //...filter_rating.minimum_review_score,
                                  filters.rating.minimum_review_score.values[review_score]
                                ],
                              })
                            }
                            else {
                              $store.commit('searching', true)
                              $store.commit('livebkv3/filter_rating', {
                                ...filter_rating,
                                minimum_review_score: filter_rating.minimum_review_score.filter(r => { return r !== filters.rating.minimum_review_score.values[review_score] }),
                              })
                            }
                          }
                        )
                      }"
                      :vb_options="{
                        type: 'light',
                        text: `${review_score}`,
                        value: filter_rating.minimum_review_score.includes(filters.rating.minimum_review_score.values[review_score]),
                      }"/>
                  </div>

                  <!-- filter rating: stars -->
                  <div class="filters__panel mb-3" v-if="filters.rating.stars && filters.rating.stars.values">
                    <p class="filters__section__title">{{ filters.rating.stars.label }}</p>

                    <vb-checkbox
                      v-for="(review_score, index) in (Object.keys(filters.rating.stars.values))"
                      v-bind:key="index"
                      @change="(value) => {
                        filter_update_handler(
                          () => {
                            if (value) {
                              $store.commit('searching', true)
                              $store.commit('livebkv3/filter_rating', {
                                ...filter_rating,
                                stars: [
                                  ...filter_rating.stars,
                                  filters.rating.stars.values[review_score]
                                ],
                              })
                            }
                            else {
                              $store.commit('searching', true)
                              $store.commit('livebkv3/filter_rating', {
                                ...filter_rating,
                                stars: filter_rating.stars.filter(r => { return r !== filters.rating.stars.values[review_score] }),
                              })
                            }
                          }
                        )
                      }"
                      :vb_options="{
                        type: 'light',
                        text: `${review_score}`,
                        value: filter_rating.stars.includes(filters.rating.stars.values[review_score]),
                      }"/>
                  </div>

                </div>
                
                <!-- filter filter travel_proud -->
                <div class="filters__panel mb-3" v-if="filters.travel_proud">
                  <div>
                    <vb-checkbox
                      @change="value => {
                        filter_update_handler(
                          () => {
                            $store.commit('livebkv3/filter_travel_proud', value)
                          }
                        )
                      }"
                      :vb_options="{
                        text: filters.travel_proud.label,
                        switch: true,
                        value: filter_travel_proud
                      }"
                    />
                  </div>
                </div>

                <!-- filter accommodation_facilities -->
                <div class="filters__panel mb-3" v-if="filters.accommodation_facilities && filters.accommodation_facilities.values">
                  <p class="filters__section__title">{{ filters.accommodation_facilities.label }}</p>
                  <vb-checkbox
                    v-for="(facility, index) in Object.keys(filters.accommodation_facilities.values)"
                    v-bind:key="index"
                    @change="(value) => {
                      filter_update_handler(
                        () => {
                          if (value) {
                            $store.commit('searching', true)
                            $store.commit('livebkv3/filter_accommodation_facilities', [
                              ...filter_accommodation_facilities,
                              facility
                            ])
                          }
                          else {
                            $store.commit('searching', true)
                            $store.commit('livebkv3/filter_accommodation_facilities', filter_accommodation_facilities.filter(a => { return a !== facility }))
                          }
                        }
                      )
                    }"
                    :vb_options="{
                      type: 'light',
                      text: `${facility}`,
                      value: filter_accommodation_facilities.includes(facility),
                    }"/>
                </div>

                <!-- filter room_facilities -->
                <div class="filters__panel mb-3" v-if="filters.room_facilities && filters.room_facilities.values">
                  <p class="filters__section__title">{{ filters.room_facilities.label }}</p>
                  <vb-checkbox
                    v-for="(facility, index) in Object.keys(filters.room_facilities.values)"
                    v-bind:key="index"
                    @change="(value) => {
                      filter_update_handler(
                        () => {
                          if (value) {
                            $store.commit('searching', true)
                            $store.commit('livebkv3/filter_room_facilities', [
                              ...filter_room_facilities,
                              facility
                            ])
                          }
                          else {
                            $store.commit('searching', true)
                            $store.commit('livebkv3/filter_room_facilities', filter_room_facilities.filter(a => { return a !== facility }))
                          }
                        }
                      )
                    }"
                    :vb_options="{
                      type: 'light',
                      text: `${facility}`,
                      value: filter_room_facilities.includes(facility),
                    }"/>
                </div>

                <!-- filter landmarks | districts | airports -->
                <div class="filters__panel mb-3">
                  <div v-for="(poi,poi_index) in ['landmarks', 'districts', 'airports']" v-bind:key="poi_index">
                    <div v-if="filters[poi] && filters[poi].values.length">
                      <p class="filters__section__title">{{ filters[poi].label }}</p>
                      <vb-checkbox
                        v-for="(poi_item, poi_item_index) in Object.keys(filters[poi].values.slice(0, poi_filter_limit))"
                        v-bind:key="poi_item_index"
                        @change="(value) => {
                          filter_update_handler(
                            () => {
                              if (value) {
                                $store.commit('searching', true)
                                $store.commit(`livebkv3/filter_poi`, filters[poi].values[poi_item])
                              }
                              else {
                                $store.commit('searching', true)
                                $store.commit(`livebkv3/filter_poi`, {ext_id: null})
                              }
                            }
                          )
                        }"
                        :vb_options="{
                          type: 'light',
                          text: filters[poi].values[poi_item].name,
                          value: filters[poi].values[poi_item].ext_id == filter_poi.ext_id,
                        }"/>
                      <vb-checkbox
                        v-if="filter_poi.ext_id && `${filter_poi.match_level}s` == poi && larger((filters[poi].values).findIndex(i => i.ext_id == filter_poi.ext_id), subtract(poi_filter_limit,1))"
                        @change="() => {
                          filter_update_handler(
                            () => {
                              $store.commit('searching', true)
                              $store.commit(`livebkv3/filter_poi`, {ext_id: null})
                            }
                          )
                        }"
                        :vb_options="{
                          type: 'light',
                          text: filter_poi.name,
                          value: true,
                        }"/>
                      <div v-if="filters[poi].values.length > poi_filter_limit">
                        <p class="text--sm text-right mb-0 text-primary underline mt-2" v-b-modal="`modal_${poi}`">Vedi tutti</p>
                        <vb-modal
                          :vb_options="{
                            id: `modal_${poi}`,
                            title: filters[poi].label,
                            size: 'xl',
                            centered: true,
                            hide_footer: true
                          }"
                        >
                          <div class="filters__section__poi">                         
                            <vb-checkbox
                              v-for="(poi_item, poi_item_index) in Object.keys(filters[poi].values)"
                              v-bind:key="poi_item_index"
                              @change="(value) => {
                                filter_update_handler(
                                  () => {
                                    if (value) {
                                      $store.commit('searching', true)
                                      $store.commit(`livebkv3/filter_poi`, filters[poi].values[poi_item])
                                    }
                                    else {
                                      $store.commit('searching', true)
                                      $store.commit(`livebkv3/filter_poi`, {ext_id: null})
                                    }
                                  }
                                )
                              }"
                              :vb_options="{
                                type: 'light',
                                text: filters[poi].values[poi_item].name,
                                value: filters[poi].values[poi_item].ext_id == filter_poi.ext_id,
                              }"/>
                          </div>
                        </vb-modal>
                      </div>
                      <hr v-if="poi !== 'airports' " class="mt-2" />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </b-col>
          
          <b-col  xs="12" xl="7" v-if="searching && !searching_from_map && !map">
            <loader  />
          </b-col>

          <b-col xs="12" xl="9" v-if="!searching || searching_from_map || map">

            <div class="filters__btn-wrapper" v-if="!appending">
              <!-- title -->
              <div v-if="searched_location_label">
                <h3 class="filters__btn-title vb-heading vb-heading--h3" v-html="searched_location_label" />
              </div>
              <!-- buttons -->
              <div class="filters__btn-content variant-white" v-if="!map">
                <vb-dropdown
                  v-if="sorters.length"
                  class="filters__btn-order mr-2"
                  :vb_options="{
                    text: sorters.filter(s => { return (s.by == sort.by && s.direction == sort.direction) })[0].label,
                    size: 'sm',
                  }"
                >
                  <b-dropdown-item v-for="(s,index) in sorters.filter(v => {
                      if (v.by == '') return false
                      return !((v.by == sort.by) && (v.direction == sort.direction))
                    })"
                    v-bind:key="_uid+'sort'+index" :active="sort == s.key || s.key == 'default_sorting' && sort == ''">
                    <div v-html="s.label"
                      @click.stop="() => {
                        $store.commit('livebkv3/sort', s)
                        search()
                      }"
                    ></div>
                  </b-dropdown-item>
                </vb-dropdown>

                <vb-button
                  class="filters__btn-panel mr-2"
                  :vb_options="{
                    text: 'Filtri',
                    size: 'sm',
                    icon: 'filter',
                  }"
                  @click="toggle_filters()"
                />

                <vb-button
                  class="filters__btn-panel"
                  :vb_options="{
                    text: 'Mappa',
                    size: 'sm',
                    icon: 'map',
                  }"
                  @click="toggle_map_view()"
                />
              </div>
            </div>

            <div class="filters__btn-content variant-white mb-3" v-if="map">
              <vb-button
                class="filters__btn-panel mx-2"
                :vb_options="{
                  text: 'Vedi su lista',
                  size: 'sm',
                  icon: 'list',
                }"
                @click="() => toggle_map_view()"
              />
            </div>            
            <div class="results__map" v-if="map" key="map">
              
              <results-google-map
                :load_more="() => search(true)"
                :loading="searching || appending"
                :load_info_window=true
                :map_markers="markers"
                :map_location="location"
                :map_info_window="{
                  offset: {x: 0, y: -40,}
                }"
                :map_style="{
                  styles: [/*snazzy maps json here */],
                }"
                :preserve_view="last_search_from_map"
                @item-clicked="i => {
                  this.$store.commit('livebkv3/selected_hotel', i.item)
                  this.$refs[i.item.id][0].navigate({})
                }"
                @map-drag="on_map_drag">
              </results-google-map>

              <div v-for="res in hotels" v-bind:key="res.id" v-show="false">
                <custom-link
                  :ref="res.id"
                  :route_name="'detail'"
                  :css_class="'d-none'"
                  :as_default="get_config('guiSettings.openDetailNewTab', false)">
                  <template #content>
                    {{ res.id }}
                  </template>
                </custom-link>
              </div>
              
            </div>
            
            <div class="results__list" v-if="!map">
              <results-content-block
                :hotels="hotels"
                :searching="searching"
                :appending="appending"
                :filters_length="active_filters().length"
                :nights="nights"
                :location="location"
                :location_separator_index="location_separator_index"
                @toggle-map="payload => toggle_map_view(payload)"
                @reset-filters="() => trigger_new_search()"
              />
              <div v-if="appending">
                <loader />
              </div>

              <div v-else-if="next_page_token" class="text-center">
                <vb-button
                  v-if="!searching"
                  @click="search(true)"
                  :vb_options="{
                    text: 'Mostra più risultati',
                  }"/>  
              </div>
            </div>

          </b-col>
        </b-row>
      </section>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { number, smallerEq, larger, max, min, subtract, floor, sum, equal, divide, round } from 'mathjs'
import ResultsContentBlock from '@bookingv3/components/views/content-blocks/results'
import GoogleMap from '@components/blocks/map'
import { service_handler } from '@services'
import { encode_parameters, decode_parameters, custom_event } from '@utilities'
import { map_markers_v3, markup, reverse_markup, round_up } from '@bookingv3/utilities'
import moment from 'moment'

/*
FILTRI
  - page filters: agiscono sui risultati di ricerca già presenti (persistono sia nello state sia nel localstorage)
  - advanced filters: a livello di UI sono dei filtri, ma a livello logico triggerano nuove ricerche
RICERCA
  - se la ricerca avviene dal booking engine (a prescindere dalla vista in cui mi trovo) questo comporta un reset di tutti i filtri (page + advanced)
  - se la ricerca avviene tramite la modifica di un filtro avanzato (possibile solo dalla modal "Filtri avanzati" in /results) allora i filtri in page vengono preservati
  NB: il reset dei filtri viene gestito tramite un payload (opzionale) che viene aggiungo all'evento search, es:
   {
    reset_page_filters: true,
    discard_advanced_filters: true,
  }
*/
export default {
  name: 'results-view',

  components: {
    'results-content-block': ResultsContentBlock,
    'results-google-map': GoogleMap,
  },

  props: {
  },

  computed: {
    // global
    ...mapState([
      'occupancy',
      'availability',
      'searching',
    ]),

    // bk
    ...mapState(
      'livebkv3', [
        'checkin',
        'checkout',
        'last_search',
        'current_search',
        'trigger_search',
        'hotels',

        // V4 filters
        'sorters',
        'filters',
        'types',
        'filter_price',
        'filter_availability',
        'filter_cancellation_type',
        'filter_accommodation_types',
        'filter_meal_plan',
        'filter_rating',
        'filter_travel_proud',
        'filter_accommodation_facilities',
        'filter_room_facilities',
        'filter_poi',

        // V4 sort
        'sort',
      ]
    ),
    min_price_bound() {
      if (!this.hotels) return 0
      if (this.hotels.length === 0) return 0
      let h = [ ...this.hotels ].sort((a,b) => subtract(a.live_price, b.live_price))
      return floor(number(h[0].live_price))
    },
    max_price_bound() {
      if (!this.hotels) return 0
      if (this.hotels.length === 0) return 0
      let h = [ ...this.hotels ].sort((a,b) => subtract(b.live_price, a.live_price))
      return floor(number(h[0].live_price))
    },
    location: {
      get() {return this.location_ || decode_parameters(this.last_search).suggestion},
      set(value) {this.location_ = value}
    },
    searched_location_label() {
      if (this.last_search_from_map) return null
      const loc = this.location_ || decode_parameters(this.last_search).suggestion
      if (!loc || loc.match_level === 'point') return null
      return loc.label || null
    },
    markers: {
      get() {
        return map_markers_v3(
          this.markers_,
          this.get_availability().total,
          this.sass
        )
      },
      set(value) {
        this.markers_ = value
      }
    },
    map_container_key() {
      // Mantiene la key stabile durante le ricerche da mappa per non rigenerare il componente
      if (this.last_search_from_map) return 'map-search'
      return this.ui_key_filter
    },
  },
  
  data() {
    return {
      show_filters: false,
      updating_price_range: false,
      focus_min_price: false,
      focus_max_price: false,
      total_properties: 0,
      next_page_token: null,
      advanced_filters: {},
      search_count: 0,
      sort_default_value: {
        label: 'Ordina per',
        by: '',
        direction: '',
      },
      map: false,
      appending: false,
      markers_: null,
      location_: null,
      nights: 0,
      search_debounce_timer: null,

      // V4
      ui_key_filter: 0,
      poi_filter_limit: 5,
      searching_from_map: false,
      last_search_from_map: false,
      location_separator_index: -1,
    }
  },

  created() {
    this.larger = larger
    this.equal = equal
    this.smallerEq = smallerEq
    this.max = max
    this.subtract = subtract
  },

  mounted() {
    // Reset separator for locations filter
    this.location_separator_index = -1;
    
    // voglio lanciare una nuova ricerca (es. atterro da un'altra pagina e voglio una nuova ricerca)
    if (this.trigger_search) this.search()

    // refresh di pagina (non ho gli hotels nello state né nel localstorage)
    else if (this.hotels.length === 0) this.search()

    // ho gli hotels nello state e devo filtrarli (es. atterro da un'altra pagina ma NON voglio una nuova ricerca)
    else {
      // ripristina il valore di nights anche se non facciamo una nuova ricerca
      const nights = moment(this.checkout).diff(moment(this.checkin), 'days')
      this.nights = nights
    }
  },

  methods: {

    update_ui_key_filter() {
      this.ui_key_filter = sum(this.ui_key_filter, 1)
    },

    async filter_update_handler(callback) {
      await this.$store.commit('searching', true)
      await this.$store.commit('livebkv3/trigger_search', false)
      await callback()
      this.update_ui_key_filter()
      this.debounced_search()
    },

    debounced_search() {
      if (this.search_debounce_timer) clearTimeout(this.search_debounce_timer)
      this.search_debounce_timer = setTimeout(() => {
        this.search()
      }, 1)
    },

    on_booking_engine_search(e) {
      this.location = null
      this.last_search_from_map = false
      if (e.reset_all_filters) {
        this.trigger_new_search()
      } else {
        this.search(e)
      }
    },

    on_map_drag(coords) {
      const location = {
        label: `${round(number(coords.latitude), 4)}, ${round(number(coords.longitude), 4)}`,
        match_level: "point",
        latitude: coords.latitude,
        longitude: coords.longitude,
      }
      this.location = location
      this.$store.commit('livebkv3/location', location)
      this.searching_from_map = true
      this.last_search_from_map = true
      this.search()
    },

    search(append = false) {
      this.update_ui_key_filter()

      const nights = moment(this.checkout).diff(moment(this.checkin), 'days')
      this.nights = nights


      if (append == true) {
        this.appending = true;
      } else {
        window.scrollTo(0,0)
        this.$store.commit('searching', true)                     // ridondante, lo lasciamo per sicurezza
        this.$store.commit('livebkv3/trigger_search', false)      // serve altrimenti la vista va in loop sul search()
        this.$store.commit('searching', true)
        this.next_page_token = null
        this.location_separator_index = -1;
      }
      
      let timestamp_start = moment().valueOf()

      let price_availability = floor(number(this.availability))

      let search_params = {
          checkin: this.checkin,
          checkout: this.checkout,
          suggestion: this.location,
          occupancy: this.occupancy,
          filters: {},
          sort: {},
        }

      if (this.filter_availability) {
        // remove markup and split per night
        const price = number(reverse_markup(price_availability).price)
        search_params.filters.price = {
          maximum: floor(divide(price, nights)), //price_availability
        }
      }
      
      if (this.filter_cancellation_type) {
        search_params.filters.cancellation_type = this.filter_cancellation_type ? 'free_cancellation' : 'non_refundable' // ridondante, lascio solo per evidenziare i valori dell'enum
      }
      
      if (this.filter_accommodation_types.length && this.filters.accommodation_types) {
        search_params.filters.accommodation_types = []
        this.filter_accommodation_types.forEach(a => {
          search_params.filters.accommodation_types = [
            ...search_params.filters.accommodation_types,
            ...this.filters.accommodation_types.values[a]
          ]
        })
      }

      if (this.filter_price.maximum) {
        const maximum = floor(number(reverse_markup(this.filter_price.maximum).price))
        search_params.filters.price = { maximum: maximum }
        if (this.filter_availability) {
          search_params.filters.price = { maximum: min(maximum, price_availability) }
        }
      }
      
      if (this.filter_meal_plan) {
        search_params.filters.meal_plan = this.filter_meal_plan
      }
     
      if (this.filter_travel_proud) {
        search_params.filters.travel_proud = this.filter_travel_proud
      }

      if (this.filter_accommodation_facilities.length && this.filters.accommodation_facilities) {
        search_params.filters.accommodation_facilities = []
        this.filter_accommodation_facilities.forEach(a => {
          search_params.filters.accommodation_facilities = [
            ...search_params.filters.accommodation_facilities,
            ...this.filters.accommodation_facilities.values[a]
          ]
        })
      }

      if (this.filter_room_facilities.length && this.filters.room_facilities) {
        search_params.filters.room_facilities = []
        this.filter_room_facilities.forEach(a => {
          search_params.filters.room_facilities = [
            ...search_params.filters.room_facilities,
            ...this.filters.room_facilities.values[a]
          ]
        })
      }

      if (this.filter_rating.minimum_review_score && this.filter_rating.minimum_review_score.length) {
        search_params.filters.rating = {
          ...search_params.filters.rating,
          minimum_review_score: this.filter_rating.minimum_review_score[0],
        }
      }

      if (this.filter_rating.stars && this.filter_rating.stars.length) {
        search_params.filters.rating = {
          ...search_params.filters.rating,
          stars: this.filter_rating.stars,
        }
      }

      // landmark | district | airports
      if (this.filter_poi.ext_id) {
        search_params.suggestion = this.filter_poi
      }

      // SORT
      if (this.sort.by) {
        if (this.sort.by !== '*') search_params.sort = this.sort
      }

      let current_search = encode_parameters(search_params)

      this.$store.commit('livebkv3/current_search', current_search)
      
      if (this.next_page_token && this.appending) search_params.next_page_token = this.next_page_token

      service_handler(
        'v4_search',
        {
          ...search_params,
          cancel_previous: true,
        },
      ).then(
        (success) => {
          const data = success.data.data
          const metadata = success.data.metadata
          let filters_enabled = metadata.filters.enabled
          
          // se sto già cercando un POI non voglio di nuovo aggiornare i POI
          if (this.filter_poi.ext_id !== null) {
            filters_enabled.landmarks = this.filters.landmarks
            filters_enabled.districts = this.filters.districts
            filters_enabled.airports = this.filters.airports
          }

          this.$store.commit('livebkv3/filters', metadata.filters.enabled)
          this.$store.commit('livebkv3/types', metadata.filters.types)
          this.$store.commit('livebkv3/sorters', [
            this.sort_default_value,
            ...metadata.sorters.enabled
          ])

          this.next_page_token = metadata.next_page_token

          let hotels = []

          if (this.appending) {
            this.total_properties = sum(metadata.count, this.total_properties)
            hotels = [
              ...this.hotels,
              ...data.accommodations,
            ]            
          }

          else {
            this.total_properties = metadata.count
            hotels = data.accommodations
          }

          // delay controllato per evitare ricerche troppo veloci
          let gap = moment().valueOf() - timestamp_start,
            min_gap = 1500,
            delay = gap < min_gap ? (min_gap - gap) : 0

          // Inject here the location separator based on first trend inversion
          if (
            this.location_separator_index < 0 && 
            metadata.expanded_search_count
          ) {
            this.location_separator_index = metadata.search_count;  
          }

          setTimeout(() => {
            hotels.forEach((h,i) => {
              h.default_sorting = i
              h.live_price = markup(h.price.total).live_price
              h.accommodations_details = {
                ...h.content,
                salabam_score: h.content.review_score,
                category: (Object.entries(this.filters.accommodation_types.values).find(entry => entry[1].includes(h.content.type_id)) || [])[0] || null
              }
            })
            this.search_count = metadata.search_count
            this.markers_ = hotels
            this.$store.commit('livebkv3/hotels', hotels)
            this.update_ui_key_filter()

            // se non ci sono risultati, chiudi i filtri mobile se aperti
            if (hotels.length === 0 && this.show_filters) {
              this.toggle_filters()
            }
            
            this.$store.commit('searching', false)
            this.searching_from_map = false
            this.appending = false

            custom_event({
              event: 'view_item_list',
              ecommerce: {
                currency: "EUR",
                items: this.parseGa4EcommerceItems(hotels),
                transaction_id: "",
                affiliation: "",
                value: 0, // Sum of (price * quantity) for all items.
                tax: 0,
                shipping: 0,
                coupon: "",
              }
            });

          }, delay)
        },
        () => {
          //this.$store.commit('searching', false)
          this.searching_from_map = false
        }
      )    
    },

    filter_keys() {
      return [
        'availability',
        'poi',
        ...Object.keys(this.filters)
      ]
    },

    get_price_filter_label(price) {
      return `${price.includes('+') ? ('Oltre '+this.filters.price.values[price].minimum) : ('Fino a '+this.filters.price.values[price].maximum)}€`
    },

    active_filters() {
      let active_filters = []

      this.filter_keys().forEach(key => {
        let filter_key = `filter_${key}`,
          callback_payload = null

        switch (filter_key) {
          case 'filter_availability':
          case 'filter_cancellation_type':
          case 'filter_travel_proud':
            if (this[filter_key]) {
              callback_payload = false
              active_filters.push({
                text: this.filters[key] ? this.filters[key].label : "Mostra in base al credito",
                callback: () => {
                  this.$store.commit(`searching`, true)
                  this.$store.commit(`livebkv3/${filter_key}`, callback_payload)
                  this.debounced_search()
                }
              })              
            }
            break

          case 'filter_accommodation_types':
          case 'filter_accommodation_facilities':
          case 'filter_room_facilities':
            this[filter_key].forEach(f => {
              active_filters.push({
                text: f,
                callback: () => {
                  this.$store.commit(`livebkv3/${filter_key}`, this[filter_key].filter(k => {return k !== f }))
                  this.debounced_search()
                }
              })              
            })
            break

          case 'filter_price':
            if (this[filter_key].minimum || this[filter_key].maximum) {
              active_filters.push({
                text: this[filter_key].label,
                callback: () => {
                  this.$store.commit(`livebkv3/${filter_key}`, {minimum: 0, maximum: 0})
                  this.debounced_search()
                }
              })
            }
            break

          case 'filter_meal_plan':
            if (!this[filter_key] == '') {
              const obj = this.filters[key].values
              callback_payload = ''
              active_filters.push({
                text: Object.keys(obj).find(key => obj[key] === this[filter_key]),
                callback: () => {
                  this.$store.commit(`searching`, true)
                  this.$store.commit(`livebkv3/${filter_key}`, callback_payload)
                  this.debounced_search()
                }
              })
            }
            break

          case 'filter_rating':
            if (this[filter_key].minimum_review_score.length) {
              this[filter_key].minimum_review_score.forEach(f => {
                const obj = this.filters[key].minimum_review_score.values
                callback_payload = ''
                active_filters.push({
                  text: Object.keys(obj).find(key => obj[key] === f),
                  callback: () => {
                    this.$store.commit(`searching`, true)
                    this.$store.commit(`livebkv3/${filter_key}`, {
                      ...this[filter_key],
                      minimum_review_score: [],
                    })
                    this.debounced_search()
                  }
                })
              })
            }

            if (this[filter_key].stars.length) {
              this[filter_key].stars.forEach(f => {
                const obj = this.filters[key].stars.values
                callback_payload = ''
                active_filters.push({
                  text: Object.keys(obj).find(key => obj[key] === f),
                  callback: () => {
                    this.$store.commit(`searching`, true)
                    this.$store.commit(`livebkv3/${filter_key}`, {
                      ...this[filter_key],
                      stars: this[filter_key].stars.filter(s => {return s !== f}),
                    })
                    this.debounced_search()
                  }
                })
              })
            }

            break
        
          case 'filter_poi':
            if (this.filter_poi.ext_id) {
              active_filters.push({
                text: this[filter_key].name,
                callback: () => {
                  this.$store.commit(`livebkv3/${filter_key}`, {ext_id: null})
                  this.debounced_search()
                }
              })
            }
            break
        }
      })

      return active_filters
    },

    reset_all_filters() {
      this.$store.commit(`searching`, true)
      this.$store.commit(`livebkv3/hotels`, [])
      this.appending = false

      this.filter_keys().forEach(key => {
        let filter_key = `filter_${key}`,
          payload = null

        switch (filter_key) {
          case 'filter_landmarks':
          case 'filter_districts':
          case 'filter_airports':
          case 'filter_24_hour_reception': // ridondante, skippo perché è anche nelle amenities
            return // gestiti come filter_poi
          case 'filter_availability':
          case 'filter_cancellation_type':
          case 'filter_travel_proud':
            payload = false
            break

          case 'filter_price':
            payload = {
              minimum: 0,
              maximum: 0,
            }
            break

          case 'filter_rating':
            payload = {
              minimum_review_score: [],
              stars: [],
            }
            break

          case 'filter_accommodation_types':
          case 'filter_accommodation_facilities':
          case 'filter_room_facilities':
            payload = []
            break

          case 'filter_meal_plan':
            payload = ''
            break
          case 'filter_poi':
            payload = {
              ext_id: null,
            }
            break
        }

        this.$store.commit(`livebkv3/${filter_key}`, payload)
      })

      this.$store.commit(`livebkv3/filters`, [])
      this.$store.commit(`livebkv3/types`, [])
    },

    trigger_new_search() {
      const saved_location_ = this.location_
      this.reset_all_filters()
      this.location_ = saved_location_
      this.debounced_search()
    },

    sort_items(items) {
      if (!items) return []
      let sort_item = this.sorters.filter(s => { return s.key == this.sort_by })[0]
      if (!sort_item) return items
      if (!sort_item.sort) return items
      return items.sort(sort_item.sort)
    },
    
    toggle_filters() {
      document.body.classList.toggle('noscroll')
      this.show_filters = !this.show_filters
    },

    toggle_map() {
      this.map = !this.map
    },

    toggle_map_view(payload = null) {
      if (payload) {
        this.markers_ = [payload]
      }
      else {
        this.markers_ = this.hotels
      }
      if (payload && payload.accommodations_details.coordinates) {
        this.location_ = {
          ...decode_parameters(this.last_search).suggestion,
          latitude: payload.accommodations_details.coordinates.latitude,
          longitude: payload.accommodations_details.coordinates.longitude,
        }
      } else if (!payload && !this.last_search_from_map) {
        this.location_ = null
      }
      window.scrollTo(0,0)
      this.toggle_map()
    },    

    parseGa4EcommerceItems(results){
      // results = filtered

      const items = [];

      results.forEach(hotel => {

        let hotelName = hotel.content.name.split(',')[0]
        let block = hotel.products[0]
        
        items.push({
          "item_id": `${hotel.id}-${block.id}`,
          "item_name": `${hotelName} - ${block.room}`,
          "item_brand": "",
          "price": round_up(markup(hotel.products[0].price.total_tax_free).live_price),
          "item_category": "",
        });

      });

      return items;

    },
  },
}
</script>

<style lang="scss">

  .toggle-map-button {
    height: 36px;
    background-color: var(--white);
    border-radius: $border-radius-lg*2;
    overflow: hidden;
    cursor: pointer;

    & > div {
      height: inherit;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }

    &__text {
      width: 50%;
      margin-right: 0.5rem;
      padding: 0 1rem;
      font-size: $font-size-md;
    }

    &__image {
      width: 50%;
      //border: 1px solid var(--light);
      height: inherit;
      display: inline-flex;
      align-items: center;
      justify-content: flex-end;
      border-radius: 4px;
      overflow: hidden;
      &>img, &>svg {
        height: 36px;
        width: auto;
      }
      &.icon {
        padding: 6px;
      }
    }
  }

  .filters {

    &__sticky-wrapper {
      //position: sticky;
      align-self: flex-start;
      top: 0;
      min-height: 100vh;
      overflow-y: scroll;
      box-shadow: 10px 0 20px 0 rgba(0, 0, 0, .3);
      @include hide-scrollbar;

      @include media-breakpoint-up(xl) {
        box-shadow: none;
      }

      &__inner {
        @include media-breakpoint-down(lg) {
          height: 100%;
          display: flex;
          flex-direction: column;;
          .filters__content-wrapper {
            overflow-y: scroll;
          }
        }
      }
    }

    &__btn {

      &-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
      }

      &-title {

        @include media-breakpoint-up(xl) {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 500px;
          margin-bottom: 0;
        }

        @include media-breakpoint-up(xxl) {
          max-width: 650px;
        }
      }
    }

    &__title {
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
    }

    &__head {
      margin-bottom: $grid-gutter-width/2;

      @include media-breakpoint-down(lg) {
        display: flex;
        justify-content: space-between;
        background: $white;
        padding: $grid-gutter-width/2 0;
        z-index: 2;
        border-bottom: 1px solid $gray-200;
        min-height: 55px;
        margin-bottom: 0;
      }

      &-element {
        margin-bottom: 0;
        line-height: normal;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      &-title {
        font-size: $font-size-lg;
        color: var(--primary);
        font-weight: $vb-font-weight-semibold;
        display: inline-block;
      }

      &-subtitle {
        color: var(--primary);
        font-size: $font-size-sm;
      }

      &-link {
        text-decoration: underline;
        font-size: $font-size-sm;
        cursor: pointer;
        color: var(--info);
        margin-left: 10px;

        * {
          white-space: nowrap;
        }
      }
    }    

    &__section__title {
      font-weight: $vb-font-weight-semibold;
      display: block;
      text-align: left;
      width: 100%;
    }

    &__section__poi {
      display: grid;
      grid-template-columns: repeat(1, minmax(0, 1fr));
      gap: 6px 12px;
      width: 100%;
      @include media-breakpoint-up(sm) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
      @include media-breakpoint-up(lg) {
        grid-template-columns: repeat(4, minmax(0, 1fr));
      }
      * {
        font-size: $font-size-md;
      }
    }

    &__section__subtitle {
      display: block;
      text-align: left;
      width: 100%;
      font-size: $font-size-sm;
      line-height: 1.2em;
      margin-top: 0.1em;
    }

    &__panel {
      background: $white;
      border-radius: $border-radius-sm;
      padding: $grid-gutter-width/2;
      .vb-check {
        &__title {
          font-size: $font-size-md;
        }
      }

      &>*:last-child {
        //margin-bottom: $grid-gutter-width/4;
      }
    }

    &__hotel-categories {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      text-align: left;
      min-width: 100%;
      &__item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        min-width: 100%;
        text-align: center;
        border: 1px solid $gray-200;
        border-radius: $btn-border-radius;
        &:not(:last-child) {
          margin-bottom: $grid-gutter-width/4;
        }
        padding: $input-btn-padding-y-lg $input-btn-padding-x-lg;
        transition: $transition-base;
        cursor: pointer;
        &:hover, &.active {
          background-color: $gray-100;
          border-color: $gray-300;
        }
        &.active {
          background-color: $gray-200;
          border-color: $gray-400;
        }
        width: calc(50% - #{$grid-gutter-width/4});
        font-size: $font-size-md;
        line-height: 120%;
        @include media-breakpoint-down(sm) {
          min-height: 55px;
        }
      }
      &__icon {
        margin-right: 8px;
      }
      &__name {
        color: $dark;
      }
    }

    &__price-range {
      display: block;
      &__item {
        width: 50%;
        display: inline-flex;
        align-items: center;
        &:first-child {
          &:after {
            content: "";
            width: 20px;
          }
        }
        .vee--errors {
          display: none !important;
        }
      }
      &__label {
        color: $gray-500;
        padding-right: 1rem;
      }
      @include media-breakpoint-up(sm) {
        &__item {
          width: auto;
          &:first-child {
            &:after {
              content: "";
              width: 60px;
              height: 1px;
              background-color: $gray-300;
              margin: 0 20px;
            }
          }
        }
      }

    }

    &__review-score {
      display: flex;
      flex-direction: column-reverse;
      &__item {
        min-width: 100%;
      }
    }

    &__advanced-badge {
      border-radius: $border-radius-sm;
      background-color: $white;
      transition: $transition-base;
      font-weight: $font-weight-normal;
      color: $dark;
      &:hover, &:focus {
        background-color: $gray-200;
      }
    }

    &__counter {
      position: absolute;
      right:0;
      top: 0;
      transform: translateY(-50%);
      font-size: $font-size-sm;
      background: $dark;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      color: $light !important;
      line-height: 120%;
      font-weight: $font-weight-bold;
    }

    &__content {

      &-close {
        position: absolute;
        top: $grid-gutter-width / 2;
        right: $grid-gutter-width / 2;

        @include media-breakpoint-up(xl) {
          display: none;
        }
      }

      &-apply {
        display: flex;
        justify-content: space-between;
        background: $white;
        padding: $grid-gutter-width/2;
        z-index: 1;
        border-top: 1px solid $gray-200;
        box-shadow: 0 -2px 16px 0 rgba(0,0,0, .16),0 0 0 1px rgba(0,0,0, .04);
        margin: 0 (-$grid-gutter-width/2);

        @include media-breakpoint-up(xl) {
          display: none;
        }
      }
    }

    &__btn-panel {
      svg {
        max-width: 16px !important;
        max-height: 16px !important;
      }
      padding: 0.15rem 0.15rem 0.2rem 0.15rem;
      @include media-breakpoint-up(xl) {
        display: none;
      }
    }

    @include media-breakpoint-down(lg) {

      &__sticky-wrapper {
        max-width: none;
        min-height: auto;
        align-self: auto;
        transform: translateX(100%);
        transition: $transition-base;

        display: flex;
        flex-direction: column;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: hidden;
        background-color: $white;
        z-index: 999; // la modal ha 1030, il pannello deve stare dietro

        .toggle-map {
          display: none;
        }

        &.visible {
          transform: translateX(0);
        }
      }

      &__content-wrapper {
        overflow-y: auto;
        padding-top: $grid-gutter-width/2;
      }

      &__btn-wrapper {
        flex-wrap: wrap;
        flex-direction: column;

        & > * {
          min-width: 100%;
        }
      }

      &__btn-content {
        min-width: 100%;
        display: flex;
        justify-content: center;
        margin-top: $grid-gutter-width/2;
      }

      &__btn-title {
        min-width: 100%;
        margin-bottom: 0;
        text-align: center;
      }

      &__btn-resume {
        text-align: center;
      }

      &__btn-order {
        margin-right: $grid-gutter-width/4;
      }

      &__btn-advanced-mobile {
        margin-top: 0;
        margin-bottom: $grid-gutter-width/4;
      }

      &__panel {
        padding-left: 0;
        padding-right: 0;
      }

      &__active-filters {
        display: none;
      }
    }

  }

  .results {
    &__map {
      max-height: 80vh;
      height: 320px;
      @include media-breakpoint-up(sm) {
        height: 400px;
      }
      @include media-breakpoint-up(md) {
        height: 600px;
      }
    }
    &__list {}
  }

  .variant-white {
    position: relative;
    .btn,
    &.btn {
      padding-right: 1.25em;
      padding-left: 1.25em;
      background-color: $white;
      color: $dark;
      border-color: transparent;
      * {
        color: $dark;
      }
      svg {
        --color: #{$dark};
      }

      &:after {
        filter: brightness(0);
      }

      &:hover, &:focus {
        border-color: transparent;
        background-color: $gray-200;
        color: $dark !important;
      }
    }

    .dropdown-menu {
      border: 1px solid $gray-200;
      font-size: $font-size-md;
      margin:0;
      padding: 0.75rem 0;
      a {
        color: inherit;
      }
      .active {
        color: $info;
      }
    }
  }

  .info-window {
    padding:6px 0 6px 6px;
    display: flex;
    flex-direction: column;
    font-size: $font-size-md;
    * {
      line-height: 120%;
    }
    &>*:not(:last-child) {
      margin-bottom: $grid-gutter-width/2;
    }
    &__image {
      width: 100%;
      height: 100px;
      overflow: hidden;
      border-radius: $border-radius-sm;
      img {
        width:100%;
        height: auto;
      }
    }

    &__text {
      display: flex;
      flex-direction: column;
      .top {
        display: flex;
        align-items: center;
        margin-bottom: $grid-gutter-width/4;
      }
      .left {
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      .right {
        text-align: right;
        padding: 0px 6px;
        font-size: $font-size-lg;
        font-weight: $vb-font-weight-semibold;
        color: $primary;
        display: flex;
        align-items: center;
      }
      .address {
        width:100%;
        font-size: $font-size-sm;
      }
      .name {
        width:100%;
        font-size: $font-size-md;
        font-weight: $vb-font-weight-semibold;
      }
      .ratings {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .stars {
        display: flex;
        align-items: center;
        flex: 2;
        svg {
          width: 16px;
          height: auto;
          margin-right: 4px;
        }
      }
      .score {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: $vb-font-weight-semibold;
        color: $info;
        text-align: center;
        flex: 1;
      }
      .copy {
        font-size: $font-size-sm;
        font-weight: $vb-font-weight-semibold;
        color: $secondary;
        margin-top: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        svg {
          width: 16px;
          height: auto;
          margin-right: 4px;
          transform: translateY(-1px);
          g {
            fill: #{$secondary};
          }
        }
      }
    }

    &__button {
      .btn {
        display: block;
        width: 100%;
      }
    }
  }

  body,html {
    &.noscroll {
      overflow: hidden;
    }
  }

  .filters__sticky-wrapper {
    transition: all 0.2s ease-in-out;

    &.clickable {
    }

    &:not(.clickable) {
      filter: blur(2px);
      opacity: 0.8;
      pointer-events: none;
    }
  }

</style>